module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        return _vm.$emit("save", _vm.product)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "flat": ""
    }
  }, [(_vm.withTitle) ? _c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("Add a new appointment type:\n      ")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.fields), function(field) {
    return _c('v-flex', _vm._b({
      key: field.value
    }, 'v-flex', field.containerAttrs, false), [(!field.component) ? _c('v-text-field', _vm._b({
      attrs: {
        "rules": [function (v) { return !!v || ((field.text) + " is required"); }],
        "label": field.text,
        "hint": field.hint
      },
      model: {
        value: (_vm.product[field.value]),
        callback: function($$v) {
          _vm.$set(_vm.product, field.value, $$v)
        },
        expression: "product[field.value]"
      }
    }, 'v-text-field', field.attrs, false)) : _c(field.component, _vm._g(_vm._b({
      tag: "component",
      model: {
        value: (_vm.product[field.value]),
        callback: function($$v) {
          _vm.$set(_vm.product, field.value, $$v)
        },
        expression: "product[field.value]"
      }
    }, 'component', field.attrs, false), field.events))], 1)
  }), 1)], 1), _vm._v(" "), _c('v-card-actions', [(_vm.withCancel) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("cancel")
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.nextRequired) ? _c('v-btn', {
    attrs: {
      "readonly": "",
      "disabled": "",
      "flat": "",
      "small": ""
    },
    domProps: {
      "textContent": _vm._s(_vm.nextRequired)
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.isValid,
      "loading": _vm.request.loading,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("save", _vm.product)
      }
    }
  }, [_vm._v("\n          Save")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7aa3bedd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/locations/AppointmentTypes.vue
// module id = 1478
// module chunks = 9